"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ForgotSceneTranslation = {
    fi: {
        ForgotScene: {
            button: 'Nollaa',
            linkText: 'Takaisin kirjautumissivulle',
            title: 'Nollaa salasana',
            subTitle: 'Kirjoita sähköpostiosoitteesi, niin lähetämme sinulle linkin, jolla voit vaihtaa salasanasi.',
            email: 'Sähköposti',
        },
    },
    en: {
        ForgotScene: {
            button: 'Reset',
            linkText: 'Back to login',
            title: 'Reset your password',
            subTitle: 'Please write your email and we send you password reset link.',
            email: 'Email',
        },
    },
};
exports.default = ForgotSceneTranslation;
//# sourceMappingURL=ForgotScene.translation.js.map